import { makeStyles } from "@material-ui/core";

export default makeStyles(() => ({
  card: {
    "marginTop": "36px",
    "& tbody tr:hover": {
      background: "rgba(200,200,200, .5)",
      cursor: "pointer",
    },
  },
}));
